<aside
  class="fixed flex flex-col top-0 px-5 left-0 bg-white dark:bg-gray-900 dark:border-gray-800 text-gray-900 h-screen transition-all duration-300 ease-in-out z-50 border-r border-gray-200"
  [ngClass]="{
    'w-[290px]': (isExpanded$ | async) || (isMobileOpen$ | async),
    'w-[90px]': !((isExpanded$ | async) || (isMobileOpen$ | async)),
    'translate-x-0': isMobileOpen$ | async,
    '-translate-x-full': !(isMobileOpen$ | async),
    'xl:translate-x-0': true,
  }"
>
  <div class="py-8 flex">
    <a routerLink="/">
      @if ((isExpanded$ | async) || (isMobileOpen$ | async)) {
        <img
          class="dark:hidden"
          src="/images/logo/logo.svg"
          alt="Logo"
          width="150"
          height="40"
        />
        <img
          class="hidden dark:block"
          src="/images/logo/logo-dark.svg"
          alt="Logo"
          width="150"
          height="40"
        />
      } @else {
        <img
          src="/images/logo/logo-icon.svg"
          alt="Logo"
          width="32"
          height="32"
        />
      }
    </a>
  </div>

  <div
    class="flex flex-col overflow-y-auto duration-300 ease-linear no-scrollbar"
  >
    <nav class="mb-6">
      <div class="flex flex-col gap-4">
        <!-- TOP LEVEL ITEMS (Dashboard & Document Tracker) -->
        <ul class="flex flex-col gap-1">
          @for (nav of topLevelItems; track $index; let i = $index) {
            <li>
              @if (nav.subItems) {
                <button
                  (click)="
                    isSidebarCollapsed()
                      ? showCollapsedSubmenu(nav, $event)
                      : toggleSubmenu('main', 'top-' + i)
                  "
                  pTooltip="{{ isSidebarCollapsed() ? nav.name : '' }}"
                  tooltipPosition="right"
                  class="menu-item group cursor-pointer relative text-gray-700 dark:text-gray-200"
                >
                  <span
                    class="menu-item-icon-size"
                    [class.menu-item-icon-active]="openSubmenu === 'top-' + i"
                    [class.menu-item-icon-inactive]="openSubmenu !== 'top-' + i"
                  >
                    <ng-container
                      *ngTemplateOutlet="
                        navIcon;
                        context: { $implicit: nav.icon }
                      "
                    ></ng-container>
                  </span>

                  @if ((isExpanded$ | async) || (isMobileOpen$ | async)) {
                    <span class="menu-item-text">{{ nav.name }}</span>
                  }

                  @if ((isExpanded$ | async) || (isMobileOpen$ | async)) {
                    <svg
                      [ngClass]="{
                        'rotate-180 text-brand-500': openSubmenu === 'top-' + i,
                      }"
                      width="1em"
                      height="1em"
                      viewBox="0 0 20 20"
                      fill="none"
                      class="ml-auto w-5 h-5 transition-transform duration-200"
                    >
                      <path
                        d="M4.79175 7.396L10.0001 12.6043L15.2084 7.396"
                        stroke="currentColor"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></path>
                    </svg>
                  }
                </button>

                <div
                  class="overflow-hidden transition-all duration-300"
                  [id]="'top-' + i"
                  [style.display]="
                    (isExpanded$ | async) || (isMobileOpen$ | async)
                      ? 'block'
                      : 'none'
                  "
                  [class.max-h-0]="openSubmenu !== 'top-' + i"
                  [class.max-h-[500px]]="openSubmenu === 'top-' + i"
                >
                  <ul class="mt-2 space-y-1 ml-9">
                    @for (subItem of nav.subItems; track $index) {
                      <li>
                        <a
                          [routerLink]="subItem.path"
                          routerLinkActive=""
                          (click)="onSubmenuClick($event)"
                          class="menu-dropdown-item"
                          [ngClass]="{
                            'menu-dropdown-item-inactive': !isActive(
                              subItem.path
                            ),
                            'menu-dropdown-item-active': isActive(subItem.path),
                          }"
                        >
                          {{ subItem.name }}
                        </a>
                      </li>
                    }
                  </ul>
                </div>
              } @else {
                @if (nav.path) {
                  <a
                    [routerLink]="nav.path"
                    class="menu-item group text-gray-700 dark:text-gray-200"
                    [ngClass]="{
                      'menu-item-active': isActive(nav.path),
                      'menu-item-inactive': !isActive(nav.path),
                    }"
                    pTooltip="{{ isSidebarCollapsed() ? nav.name : '' }}"
                    tooltipPosition="right"
                  >
                    <span
                      class="menu-item-icon-size"
                      [ngClass]="{
                        'menu-item-icon-active': isActive(nav.path),
                        'menu-item-icon-inactive': !isActive(nav.path),
                      }"
                    >
                      <ng-container
                        *ngTemplateOutlet="
                          navIcon;
                          context: { $implicit: nav.icon }
                        "
                      ></ng-container>
                    </span>
                    @if ((isExpanded$ | async) || (isMobileOpen$ | async)) {
                      <span class="menu-item-text">{{ nav.name }}</span>
                    }
                  </a>
                }
              }
            </li>
          }
        </ul>

        <!-- MAP SECTION -->
        <div *ngIf="mapItems.length > 0">
          <h2
            class="mb-4 text-sm uppercase flex leading-[20px] text-gray-600 dark:text-gray-300"
            [ngClass]="{
              'xl:justify-center': !(isExpanded$ | async),
              'justify-start': (isExpanded$ | async),
            }"
          >
            @if ((isExpanded$ | async) || (isMobileOpen$ | async)) {
              Map
            } @else {
              <svg
                width="1em"
                height="1em"
                viewBox="0 0 24 24"
                fill="none"
                class="size-6"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M5.99915 10.2451C6.96564 10.2451 7.74915 11.0286 7.74915 11.9951V12.0051C7.74915 12.9716 6.96564 13.7551 5.99915 13.7551C5.03265 13.7551 4.24915 12.9716 4.24915 12.0051V11.9951C4.24915 11.0286 5.03265 10.2451 5.99915 10.2451ZM17.9991 10.2451C18.9656 10.2451 19.7491 11.0286 19.7491 11.9951V12.0051C19.7491 12.9716 18.9656 13.7551 17.9991 13.7551C17.0326 13.7551 16.2491 12.9716 16.2491 12.0051V11.9951C16.2491 11.0286 17.0326 10.2451 17.9991 10.2451ZM13.7491 11.9951C13.7491 11.0286 12.9656 10.2451 11.9991 10.2451C11.0326 10.2451 10.2491 11.0286 10.2491 11.9951V12.0051C10.2491 12.9716 11.0326 13.7551 11.9991 13.7551C12.9656 13.7551 13.7491 12.9716 13.7491 12.0051V11.9951Z"
                  fill="currentColor"
                ></path>
              </svg>
            }
          </h2>

          <ul class="flex flex-col gap-1">
            @for (nav of mapItems; track $index; let i = $index) {
              <li>
                @if (nav.subItems) {
                  <button
                    (click)="
                      isSidebarCollapsed()
                        ? showCollapsedSubmenu(nav, $event)
                        : toggleSubmenu('main', 'main-' + i)
                    "
                    pTooltip="{{ isSidebarCollapsed() ? nav.name : '' }}"
                    tooltipPosition="right"
                    class="menu-item group cursor-pointer relative text-gray-700 dark:text-gray-200"
                  >
                    <span class="menu-item-icon-size">
                      <ng-container
                        *ngTemplateOutlet="
                          navIcon;
                          context: { $implicit: nav.icon }
                        "
                      ></ng-container>
                    </span>
                    @if ((isExpanded$ | async) || (isMobileOpen$ | async)) {
                      <span class="menu-item-text">{{ nav.name }}</span>
                    }
                    @if ((isExpanded$ | async) || (isMobileOpen$ | async)) {
                      <svg
                        [ngClass]="{
                          'rotate-180 text-brand-500':
                            openSubmenu === 'main-' + i,
                        }"
                        width="1em"
                        height="1em"
                        viewBox="0 0 20 20"
                        fill="none"
                        class="ml-auto w-5 h-5 transition-transform duration-200"
                      >
                        <path
                          d="M4.79175 7.396L10.0001 12.6043L15.2084 7.396"
                          stroke="currentColor"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        ></path>
                      </svg>
                    }
                  </button>

                  <div
                    class="overflow-hidden transition-all duration-300"
                    [id]="'main-' + i"
                    [style.display]="
                      (isExpanded$ | async) || (isMobileOpen$ | async)
                        ? 'block'
                        : 'none'
                    "
                    [class.max-h-0]="openSubmenu !== 'main-' + i"
                    [class.max-h-[500px]]="openSubmenu === 'main-' + i"
                  >
                    <ul class="mt-2 space-y-1 ml-9">
                      @for (
                        subItem of nav.subItems;
                        track $index;
                        let j = $index
                      ) {
                        <li>
                          @if (hasNestedSubItems(subItem)) {
                            <button
                              type="button"
                              (click)="
                                toggleSubmenu(
                                  'nested',
                                  'main-' + i + '-sub-' + j
                                )
                              "
                              class="w-full flex items-center gap-2 px-3 py-2 rounded-md transition text-sm menu-dropdown-item"
                              [ngStyle]="{
                                color:
                                  openNestedSubmenu ===
                                  'main-' + i + '-sub-' + j
                                    ? 'var(--color-brand-500)'
                                    : 'var',
                              }"
                            >
                              <span>{{ getSubItemName(subItem) }}</span>
                              <svg
                                width="1em"
                                height="1em"
                                viewBox="0 0 20 20"
                                fill="none"
                                class="ml-auto w-4 h-4 transition-transform duration-200"
                                [ngClass]="{
                                  'rotate-180':
                                    openNestedSubmenu ===
                                    'main-' + i + '-sub-' + j,
                                }"
                              >
                                <path
                                  d="M4.79175 7.396L10.0001 12.6043L15.2084 7.396"
                                  stroke="currentColor"
                                  stroke-width="1.5"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                ></path>
                              </svg>
                            </button>
                            <div
                              class="overflow-hidden transition-all duration-300 ml-4"
                              [id]="'main-' + i + '-sub-' + j"
                              [ngStyle]="{
                                height:
                                  openNestedSubmenu ===
                                  'main-' + i + '-sub-' + j
                                    ? (subMenuHeights[
                                        'main-' + i + '-sub-' + j
                                      ] || 0) + 'px'
                                    : '0px',
                              }"
                            >
                              <ul class="mt-1 space-y-1">
                                @for (
                                  nestedItem of getNestedSubItems(subItem);
                                  track $index
                                ) {
                                  <li>
                                    <a
                                      [routerLink]="nestedItem.path"
                                      routerLinkActive=""
                                      (click)="onSubmenuClick($event)"
                                      class="menu-dropdown-item pl-4"
                                      [ngClass]="{
                                        'menu-dropdown-item-inactive':
                                          !isActive(nestedItem.path),
                                        'menu-dropdown-item-active': isActive(
                                          nestedItem.path
                                        ),
                                      }"
                                    >
                                      {{ nestedItem.name }}
                                    </a>
                                  </li>
                                }
                              </ul>
                            </div>
                          } @else {
                            @if (getSubItemPath(subItem)) {
                              <a
                                [routerLink]="getSubItemPath(subItem)"
                                routerLinkActive=""
                                (click)="onSubmenuClick($event)"
                                class="menu-dropdown-item"
                                [ngClass]="{
                                  'menu-dropdown-item-inactive': !isActive(
                                    getSubItemPath(subItem) ?? ''
                                  ),
                                  'menu-dropdown-item-active': isActive(
                                    getSubItemPath(subItem) ?? ''
                                  ),
                                }"
                              >
                                {{ getSubItemName(subItem) }}
                              </a>
                            }
                          }
                        </li>
                      }
                    </ul>
                  </div>
                } @else {
                  @if (nav.path) {
                    <a
                      [routerLink]="nav.path"
                      class="menu-item group text-gray-700 dark:text-gray-200"
                      [ngClass]="{
                        'menu-item-active': isActive(nav.path),
                        'menu-item-inactive': !isActive(nav.path),
                      }"
                      pTooltip="{{ isSidebarCollapsed() ? nav.name : '' }}"
                      tooltipPosition="right"
                    >
                      <span class="menu-item-icon-size">
                        <ng-container
                          *ngTemplateOutlet="
                            navIcon;
                            context: { $implicit: nav.icon }
                          "
                        ></ng-container>
                      </span>
                      @if ((isExpanded$ | async) || (isMobileOpen$ | async)) {
                        <span class="menu-item-text">{{ nav.name }}</span>
                      }
                    </a>
                  }
                }
              </li>
            }
          </ul>
        </div>

        <!-- FILE DEFINITION SECTION -->
        <div *ngIf="fileDefinitionItems.length > 0">
          <h2
            class="mb-4 text-sm uppercase flex leading-[20px] text-gray-600 dark:text-gray-300"
            [ngClass]="{
              'xl:justify-center': !(isExpanded$ | async),
              'justify-start': (isExpanded$ | async),
            }"
          >
            @if ((isExpanded$ | async) || (isMobileOpen$ | async)) {
              File Definition
            } @else {
              <svg
                width="1em"
                height="1em"
                viewBox="0 0 24 24"
                fill="none"
                class="size-6"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M5.99915 10.2451C6.96564 10.2451 7.74915 11.0286 7.74915 11.9951V12.0051C7.74915 12.9716 6.96564 13.7551 5.99915 13.7551C5.03265 13.7551 4.24915 12.9716 4.24915 12.0051V11.9951C4.24915 11.0286 5.03265 10.2451 5.99915 10.2451ZM17.9991 10.2451C18.9656 10.2451 19.7491 11.0286 19.7491 11.9951V12.0051C19.7491 12.9716 18.9656 13.7551 17.9991 13.7551C17.0326 13.7551 16.2491 12.9716 16.2491 12.0051V11.9951C16.2491 11.0286 17.0326 10.2451 17.9991 10.2451ZM13.7491 11.9951C13.7491 11.0286 12.9656 10.2451 11.9991 10.2451C11.0326 10.2451 10.2491 11.0286 10.2491 11.9951V12.0051C10.2491 12.9716 11.0326 13.7551 11.9991 13.7551C12.9656 13.7551 13.7491 12.9716 13.7491 12.0051V11.9951Z"
                  fill="currentColor"
                ></path>
              </svg>
            }
          </h2>

          <ul class="flex flex-col gap-1">
            @for (nav of fileDefinitionItems; track $index; let i = $index) {
              <li>
                @if (nav.subItems) {
                  <button
                    (click)="
                      isSidebarCollapsed()
                        ? showCollapsedSubmenu(nav, $event)
                        : toggleSubmenu('main', 'file-' + i)
                    "
                    pTooltip="{{ isSidebarCollapsed() ? nav.name : '' }}"
                    tooltipPosition="right"
                    class="menu-item group cursor-pointer relative text-gray-700 dark:text-gray-200"
                  >
                    <span class="menu-item-icon-size">
                      <ng-container
                        *ngTemplateOutlet="
                          navIcon;
                          context: { $implicit: nav.icon }
                        "
                      ></ng-container>
                    </span>
                    @if ((isExpanded$ | async) || (isMobileOpen$ | async)) {
                      <span class="menu-item-text">{{ nav.name }}</span>
                    }
                    @if ((isExpanded$ | async) || (isMobileOpen$ | async)) {
                      <svg
                        [ngClass]="{
                          'rotate-180 text-brand-500':
                            openSubmenu === 'file-' + i,
                        }"
                        width="1em"
                        height="1em"
                        viewBox="0 0 20 20"
                        fill="none"
                        class="ml-auto w-5 h-5 transition-transform duration-200"
                      >
                        <path
                          d="M4.79175 7.396L10.0001 12.6043L15.2084 7.396"
                          stroke="currentColor"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        ></path>
                      </svg>
                    }
                  </button>

                  <div
                    class="overflow-hidden transition-all duration-300"
                    [id]="'file-' + i"
                    [style.display]="
                      (isExpanded$ | async) || (isMobileOpen$ | async)
                        ? 'block'
                        : 'none'
                    "
                    [class.max-h-0]="openSubmenu !== 'file-' + i"
                    [class.max-h-[500px]]="openSubmenu === 'file-' + i"
                  >
                    <ul class="mt-2 space-y-1 ml-9">
                      @for (
                        subItem of nav.subItems;
                        track $index;
                        let j = $index
                      ) {
                        <li>
                          @if (hasNestedSubItems(subItem)) {
                            <button
                              type="button"
                              (click)="
                                toggleSubmenu(
                                  'nested',
                                  'file-' + i + '-sub-' + j
                                )
                              "
                              class="w-full flex items-center gap-2 px-3 py-2 rounded-md transition text-sm menu-dropdown-item"
                              [ngStyle]="{
                                color:
                                  openNestedSubmenu ===
                                  'file-' + i + '-sub-' + j
                                    ? 'var(--color-brand-500)'
                                    : 'var',
                              }"
                            >
                              <span>{{ getSubItemName(subItem) }}</span>
                              <svg
                                width="1em"
                                height="1em"
                                viewBox="0 0 20 20"
                                fill="none"
                                class="ml-auto w-4 h-4 transition-transform duration-200"
                                [ngClass]="{
                                  'rotate-180':
                                    openNestedSubmenu ===
                                    'file-' + i + '-sub-' + j,
                                }"
                              >
                                <path
                                  d="M4.79175 7.396L10.0001 12.6043L15.2084 7.396"
                                  stroke="currentColor"
                                  stroke-width="1.5"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                ></path>
                              </svg>
                            </button>
                            <div
                              class="overflow-hidden transition-all duration-300 ml-4"
                              [id]="'file-' + i + '-sub-' + j"
                              [ngStyle]="{
                                height:
                                  openNestedSubmenu ===
                                  'file-' + i + '-sub-' + j
                                    ? (subMenuHeights[
                                        'file-' + i + '-sub-' + j
                                      ] || 0) + 'px'
                                    : '0px',
                              }"
                            >
                              <ul class="mt-1 space-y-1">
                                @for (
                                  nestedItem of getNestedSubItems(subItem);
                                  track $index
                                ) {
                                  <li>
                                    <a
                                      [routerLink]="nestedItem.path"
                                      routerLinkActive=""
                                      (click)="onSubmenuClick($event)"
                                      class="menu-dropdown-item pl-4"
                                      [ngClass]="{
                                        'menu-dropdown-item-inactive':
                                          !isActive(nestedItem.path),
                                        'menu-dropdown-item-active': isActive(
                                          nestedItem.path
                                        ),
                                      }"
                                    >
                                      {{ nestedItem.name }}
                                    </a>
                                  </li>
                                }
                              </ul>
                            </div>
                          } @else {
                            @if (getSubItemPath(subItem)) {
                              <a
                                [routerLink]="getSubItemPath(subItem)"
                                routerLinkActive=""
                                (click)="onSubmenuClick($event)"
                                class="menu-dropdown-item"
                                [ngClass]="{
                                  'menu-dropdown-item-inactive': !isActive(
                                    getSubItemPath(subItem) ?? ''
                                  ),
                                  'menu-dropdown-item-active': isActive(
                                    getSubItemPath(subItem) ?? ''
                                  ),
                                }"
                              >
                                {{ getSubItemName(subItem) }}
                              </a>
                            }
                          }
                        </li>
                      }
                    </ul>
                  </div>
                } @else {
                  @if (nav.path) {
                    <a
                      [routerLink]="nav.path"
                      class="menu-item group text-gray-700 dark:text-gray-200"
                      [ngClass]="{
                        'menu-item-active': isActive(nav.path),
                        'menu-item-inactive': !isActive(nav.path),
                      }"
                      pTooltip="{{ isSidebarCollapsed() ? nav.name : '' }}"
                      tooltipPosition="right"
                    >
                      <span class="menu-item-icon-size">
                        <ng-container
                          *ngTemplateOutlet="
                            navIcon;
                            context: { $implicit: nav.icon }
                          "
                        ></ng-container>
                      </span>
                      @if ((isExpanded$ | async) || (isMobileOpen$ | async)) {
                        <span class="menu-item-text">{{ nav.name }}</span>
                      }
                    </a>
                  }
                }
              </li>
            }
          </ul>
        </div>

        <!-- PARTNER MANAGEMENT SECTION -->
        <div *ngIf="partnerManagementItems.length > 0">
          <h2
            class="mb-4 text-sm uppercase flex leading-[20px] text-gray-600 dark:text-gray-300"
            [ngClass]="{
              'xl:justify-center': !(isExpanded$ | async),
              'justify-start': (isExpanded$ | async),
            }"
          >
            @if ((isExpanded$ | async) || (isMobileOpen$ | async)) {
              Partner Management
            } @else {
              <svg
                width="1em"
                height="1em"
                viewBox="0 0 24 24"
                fill="none"
                class="size-6"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M5.99915 10.2451C6.96564 10.2451 7.74915 11.0286 7.74915 11.9951V12.0051C7.74915 12.9716 6.96564 13.7551 5.99915 13.7551C5.03265 13.7551 4.24915 12.9716 4.24915 12.0051V11.9951C4.24915 11.0286 5.03265 10.2451 5.99915 10.2451ZM17.9991 10.2451C18.9656 10.2451 19.7491 11.0286 19.7491 11.9951V12.0051C19.7491 12.9716 18.9656 13.7551 17.9991 13.7551C17.0326 13.7551 16.2491 12.9716 16.2491 12.0051V11.9951C16.2491 11.0286 17.0326 10.2451 17.9991 10.2451ZM13.7491 11.9951C13.7491 11.0286 12.9656 10.2451 11.9991 10.2451C11.0326 10.2451 10.2491 11.0286 10.2491 11.9951V12.0051C10.2491 12.9716 11.0326 13.7551 11.9991 13.7551C12.9656 13.7551 13.7491 12.9716 13.7491 12.0051V11.9951Z"
                  fill="currentColor"
                ></path>
              </svg>
            }
          </h2>

          <ul class="flex flex-col gap-1">
            @for (nav of partnerManagementItems; track $index; let i = $index) {
              <li>
                @if (nav.subItems) {
                  <button
                    (click)="
                      isSidebarCollapsed()
                        ? showCollapsedSubmenu(nav, $event)
                        : toggleSubmenu('main', 'partner-' + i)
                    "
                    pTooltip="{{ isSidebarCollapsed() ? nav.name : '' }}"
                    tooltipPosition="right"
                    class="menu-item group cursor-pointer relative text-gray-700 dark:text-gray-200"
                  >
                    <span class="menu-item-icon-size">
                      <ng-container
                        *ngTemplateOutlet="
                          navIcon;
                          context: { $implicit: nav.icon }
                        "
                      ></ng-container>
                    </span>
                    @if ((isExpanded$ | async) || (isMobileOpen$ | async)) {
                      <span class="menu-item-text">{{ nav.name }}</span>
                    }
                    @if ((isExpanded$ | async) || (isMobileOpen$ | async)) {
                      <svg
                        [ngClass]="{
                          'rotate-180 text-brand-500':
                            openSubmenu === 'partner-' + i,
                        }"
                        width="1em"
                        height="1em"
                        viewBox="0 0 20 20"
                        fill="none"
                        class="ml-auto w-5 h-5 transition-transform duration-200"
                      >
                        <path
                          d="M4.79175 7.396L10.0001 12.6043L15.2084 7.396"
                          stroke="currentColor"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        ></path>
                      </svg>
                    }
                  </button>

                  <div
                    class="overflow-hidden transition-all duration-300"
                    [id]="'partner-' + i"
                    [style.display]="
                      (isExpanded$ | async) || (isMobileOpen$ | async)
                        ? 'block'
                        : 'none'
                    "
                    [class.max-h-0]="openSubmenu !== 'partner-' + i"
                    [class.max-h-[500px]]="openSubmenu === 'partner-' + i"
                  >
                    <ul class="mt-2 space-y-1 ml-9">
                      @for (
                        subItem of nav.subItems;
                        track $index;
                        let j = $index
                      ) {
                        <li>
                          @if (hasNestedSubItems(subItem)) {
                            <button
                              type="button"
                              (click)="
                                toggleSubmenu(
                                  'nested',
                                  'partner-' + i + '-sub-' + j
                                )
                              "
                              class="w-full flex items-center gap-2 px-3 py-2 rounded-md transition text-sm menu-dropdown-item"
                              [ngStyle]="{
                                color:
                                  openNestedSubmenu ===
                                  'partner-' + i + '-sub-' + j
                                    ? 'var(--color-brand-500)'
                                    : 'var',
                              }"
                            >
                              <span>{{ getSubItemName(subItem) }}</span>
                              <svg
                                width="1em"
                                height="1em"
                                viewBox="0 0 20 20"
                                fill="none"
                                class="ml-auto w-4 h-4 transition-transform duration-200"
                                [ngClass]="{
                                  'rotate-180':
                                    openNestedSubmenu ===
                                    'partner-' + i + '-sub-' + j,
                                }"
                              >
                                <path
                                  d="M4.79175 7.396L10.0001 12.6043L15.2084 7.396"
                                  stroke="currentColor"
                                  stroke-width="1.5"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                ></path>
                              </svg>
                            </button>
                            <div
                              class="overflow-hidden transition-all duration-300 ml-4"
                              [id]="'partner-' + i + '-sub-' + j"
                              [ngStyle]="{
                                height:
                                  openNestedSubmenu ===
                                  'partner-' + i + '-sub-' + j
                                    ? (subMenuHeights[
                                        'partner-' + i + '-sub-' + j
                                      ] || 0) + 'px'
                                    : '0px',
                              }"
                            >
                              <ul class="mt-1 space-y-1">
                                @for (
                                  nestedItem of getNestedSubItems(subItem);
                                  track $index
                                ) {
                                  <li>
                                    <a
                                      [routerLink]="nestedItem.path"
                                      routerLinkActive=""
                                      (click)="onSubmenuClick($event)"
                                      class="menu-dropdown-item pl-4"
                                      [ngClass]="{
                                        'menu-dropdown-item-inactive':
                                          !isActive(nestedItem.path),
                                        'menu-dropdown-item-active': isActive(
                                          nestedItem.path
                                        ),
                                      }"
                                    >
                                      {{ nestedItem.name }}
                                    </a>
                                  </li>
                                }
                              </ul>
                            </div>
                          } @else {
                            @if (getSubItemPath(subItem)) {
                              <a
                                [routerLink]="getSubItemPath(subItem)"
                                routerLinkActive=""
                                (click)="onSubmenuClick($event)"
                                class="menu-dropdown-item"
                                [ngClass]="{
                                  'menu-dropdown-item-inactive': !isActive(
                                    getSubItemPath(subItem) ?? ''
                                  ),
                                  'menu-dropdown-item-active': isActive(
                                    getSubItemPath(subItem) ?? ''
                                  ),
                                }"
                              >
                                {{ getSubItemName(subItem) }}
                              </a>
                            }
                          }
                        </li>
                      }
                    </ul>
                  </div>
                } @else {
                  @if (nav.path) {
                    <a
                      [routerLink]="nav.path"
                      class="menu-item group text-gray-700 dark:text-gray-200"
                      [ngClass]="{
                        'menu-item-active': isActive(nav.path),
                        'menu-item-inactive': !isActive(nav.path),
                      }"
                      pTooltip="{{ isSidebarCollapsed() ? nav.name : '' }}"
                      tooltipPosition="right"
                    >
                      <span class="menu-item-icon-size">
                        <ng-container
                          *ngTemplateOutlet="
                            navIcon;
                            context: { $implicit: nav.icon }
                          "
                        ></ng-container>
                      </span>
                      @if ((isExpanded$ | async) || (isMobileOpen$ | async)) {
                        <span class="menu-item-text">{{ nav.name }}</span>
                      }
                    </a>
                  }
                }
              </li>
            }
          </ul>
        </div>

        <!-- ADMINISTRATION SECTION -->
        <div *ngIf="administrationItems.length > 0">
          <h2
            class="mb-4 text-sm uppercase flex leading-[20px] text-gray-600 dark:text-gray-300"
            [ngClass]="{
              'xl:justify-center': !(isExpanded$ | async),
              'justify-start': (isExpanded$ | async),
            }"
          >
            @if ((isExpanded$ | async) || (isMobileOpen$ | async)) {
              Administration
            } @else {
              <svg
                width="1em"
                height="1em"
                viewBox="0 0 24 24"
                fill="none"
                class="size-6"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M5.99915 10.2451C6.96564 10.2451 7.74915 11.0286 7.74915 11.9951V12.0051C7.74915 12.9716 6.96564 13.7551 5.99915 13.7551C5.03265 13.7551 4.24915 12.9716 4.24915 12.0051V11.9951C4.24915 11.0286 5.03265 10.2451 5.99915 10.2451ZM17.9991 10.2451C18.9656 10.2451 19.7491 11.0286 19.7491 11.9951V12.0051C19.7491 12.9716 18.9656 13.7551 17.9991 13.7551C17.0326 13.7551 16.2491 12.9716 16.2491 12.0051V11.9951C16.2491 11.0286 17.0326 10.2451 17.9991 10.2451ZM13.7491 11.9951C13.7491 11.0286 12.9656 10.2451 11.9991 10.2451C11.0326 10.2451 10.2491 11.0286 10.2491 11.9951V12.0051C10.2491 12.9716 11.0326 13.7551 11.9991 13.7551C12.9656 13.7551 13.7491 12.9716 13.7491 12.0051V11.9951Z"
                  fill="currentColor"
                ></path>
              </svg>
            }
          </h2>

          <ul class="flex flex-col gap-1">
            @for (nav of administrationItems; track $index; let i = $index) {
              @if (nav.name !== "Status Management" || isSuperAdmin()) {
                <li>
                  @if (nav.path) {
                    <a
                      [routerLink]="nav.path"
                      class="menu-item group text-gray-700 dark:text-gray-200"
                      [ngClass]="{
                        'menu-item-active': isActive(nav.path),
                        'menu-item-inactive': !isActive(nav.path),
                      }"
                      pTooltip="{{ isSidebarCollapsed() ? nav.name : '' }}"
                      tooltipPosition="right"
                    >
                      <span
                        class="menu-item-icon-size"
                        [ngClass]="{
                          'menu-item-icon-active': isActive(nav.path),
                          'menu-item-icon-inactive': !isActive(nav.path),
                        }"
                      >
                        <ng-container
                          *ngTemplateOutlet="
                            navIcon;
                            context: { $implicit: nav.icon }
                          "
                        ></ng-container>
                      </span>
                      @if ((isExpanded$ | async) || (isMobileOpen$ | async)) {
                        <span class="menu-item-text">{{ nav.name }}</span>
                      }
                    </a>
                  }
                </li>
              }
            }
          </ul>
        </div>

        <!-- MIGRATION SECTION -->
        <div *ngIf="migrationItems.length > 0">
          <h2
            class="mb-4 text-sm uppercase flex leading-[20px] text-gray-600 dark:text-gray-300"
            [ngClass]="{
              'xl:justify-center': !(isExpanded$ | async),
              'justify-start': (isExpanded$ | async),
            }"
          >
            @if ((isExpanded$ | async) || (isMobileOpen$ | async)) {
              Migration
            } @else {
              <svg
                width="1em"
                height="1em"
                viewBox="0 0 24 24"
                fill="none"
                class="size-6"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M5.99915 10.2451C6.96564 10.2451 7.74915 11.0286 7.74915 11.9951V12.0051C7.74915 12.9716 6.96564 13.7551 5.99915 13.7551C5.03265 13.7551 4.24915 12.9716 4.24915 12.0051V11.9951C4.24915 11.0286 5.03265 10.2451 5.99915 10.2451ZM17.9991 10.2451C18.9656 10.2451 19.7491 11.0286 19.7491 11.9951V12.0051C19.7491 12.9716 18.9656 13.7551 17.9991 13.7551C17.0326 13.7551 16.2491 12.9716 16.2491 12.0051V11.9951C16.2491 11.0286 17.0326 10.2451 17.9991 10.2451ZM13.7491 11.9951C13.7491 11.0286 12.9656 10.2451 11.9991 10.2451C11.0326 10.2451 10.2491 11.0286 10.2491 11.9951V12.0051C10.2491 12.9716 11.0326 13.7551 11.9991 13.7551C12.9656 13.7551 13.7491 12.9716 13.7491 12.0051V11.9951Z"
                  fill="currentColor"
                ></path>
              </svg>
            }
          </h2>

          <ul class="flex flex-col gap-1">
            @for (nav of migrationItems; track $index) {
              <li>
                @if (nav.path) {
                  <a
                    [routerLink]="nav.path"
                    class="menu-item group text-gray-700 dark:text-gray-200"
                    [ngClass]="{
                      'menu-item-active': isActive(nav.path),
                      'menu-item-inactive': !isActive(nav.path),
                    }"
                    pTooltip="{{ isSidebarCollapsed() ? nav.name : '' }}"
                    tooltipPosition="right"
                  >
                    <span
                      class="menu-item-icon-size"
                      [ngClass]="{
                        'menu-item-icon-active': isActive(nav.path),
                        'menu-item-icon-inactive': !isActive(nav.path),
                      }"
                    >
                      <ng-container
                        *ngTemplateOutlet="
                          navIcon;
                          context: { $implicit: nav.icon }
                        "
                      ></ng-container>
                    </span>
                    @if ((isExpanded$ | async) || (isMobileOpen$ | async)) {
                      <span class="menu-item-text">{{ nav.name }}</span>
                    }
                  </a>
                }
              </li>
            }
          </ul>
        </div>

        <!-- CONFIGURATION SECTION -->
        <div *ngIf="configurationItems.length > 0">
          <h2
            class="mb-4 text-sm uppercase flex leading-[20px] text-gray-600 dark:text-gray-300"
            [ngClass]="{
              'xl:justify-center': !(isExpanded$ | async),
              'justify-start': (isExpanded$ | async),
            }"
          >
            @if ((isExpanded$ | async) || (isMobileOpen$ | async)) {
              Configuration
            } @else {
              <svg
                width="1em"
                height="1em"
                viewBox="0 0 24 24"
                fill="none"
                class="size-6"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M5.99915 10.2451C6.96564 10.2451 7.74915 11.0286 7.74915 11.9951V12.0051C7.74915 12.9716 6.96564 13.7551 5.99915 13.7551C5.03265 13.7551 4.24915 12.9716 4.24915 12.0051V11.9951C4.24915 11.0286 5.03265 10.2451 5.99915 10.2451ZM17.9991 10.2451C18.9656 10.2451 19.7491 11.0286 19.7491 11.9951V12.0051C19.7491 12.9716 18.9656 13.7551 17.9991 13.7551C17.0326 13.7551 16.2491 12.9716 16.2491 12.0051V11.9951C16.2491 11.0286 17.0326 10.2451 17.9991 10.2451ZM13.7491 11.9951C13.7491 11.0286 12.9656 10.2451 11.9991 10.2451C11.0326 10.2451 10.2491 11.0286 10.2491 11.9951V12.0051C10.2491 12.9716 11.0326 13.7551 11.9991 13.7551C12.9656 13.7551 13.7491 12.9716 13.7491 12.0051V11.9951Z"
                  fill="currentColor"
                ></path>
              </svg>
            }
          </h2>

          <ul class="flex flex-col gap-1">
            @for (nav of configurationItems; track $index; let i = $index) {
              <li>
                @if (nav.path) {
                  <a
                    [routerLink]="nav.path"
                    class="menu-item group text-gray-700 dark:text-gray-200"
                    [ngClass]="{
                      'menu-item-active': isActive(nav.path),
                      'menu-item-inactive': !isActive(nav.path),
                    }"
                    pTooltip="{{ isSidebarCollapsed() ? nav.name : '' }}"
                    tooltipPosition="right"
                  >
                    <span
                      class="menu-item-icon-size"
                      [ngClass]="{
                        'menu-item-icon-active': isActive(nav.path),
                        'menu-item-icon-inactive': !isActive(nav.path),
                      }"
                    >
                      <ng-container
                        *ngTemplateOutlet="
                          navIcon;
                          context: { $implicit: nav.icon }
                        "
                      ></ng-container>
                    </span>
                    @if ((isExpanded$ | async) || (isMobileOpen$ | async)) {
                      <span class="menu-item-text">{{ nav.name }}</span>
                    }
                  </a>
                }
              </li>
            }
          </ul>
        </div>

        <!-- DEVELOPER SECTION -->
        <div *ngIf="developerItems.length > 0">
          <h2
            class="mb-4 text-sm uppercase flex leading-[20px] text-gray-600 dark:text-gray-300"
            [ngClass]="{
              'xl:justify-center': !(isExpanded$ | async),
              'justify-start': (isExpanded$ | async),
            }"
          >
            @if ((isExpanded$ | async) || (isMobileOpen$ | async)) {
              Developer
            } @else {
              <svg
                width="1em"
                height="1em"
                viewBox="0 0 24 24"
                fill="none"
                class="size-6"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M5.99915 10.2451C6.96564 10.2451 7.74915 11.0286 7.74915 11.9951V12.0051C7.74915 12.9716 6.96564 13.7551 5.99915 13.7551C5.03265 13.7551 4.24915 12.9716 4.24915 12.0051V11.9951C4.24915 11.0286 5.03265 10.2451 5.99915 10.2451ZM17.9991 10.2451C18.9656 10.2451 19.7491 11.0286 19.7491 11.9951V12.0051C19.7491 12.9716 18.9656 13.7551 17.9991 13.7551C17.0326 13.7551 16.2491 12.9716 16.2491 12.0051V11.9951C16.2491 11.0286 17.0326 10.2451 17.9991 10.2451ZM13.7491 11.9951C13.7491 11.0286 12.9656 10.2451 11.9991 10.2451C11.0326 10.2451 10.2491 11.0286 10.2491 11.9951V12.0051C10.2491 12.9716 11.0326 13.7551 11.9991 13.7551C12.9656 13.7551 13.7491 12.9716 13.7491 12.0051V11.9951Z"
                  fill="currentColor"
                ></path>
              </svg>
            }
          </h2>

          <ul class="flex flex-col gap-1">
            @for (nav of developerItems; track $index) {
              <li>
                @if (nav.path) {
                  <a
                    [routerLink]="nav.path"
                    class="menu-item group text-gray-700 dark:text-gray-200"
                    [ngClass]="{
                      'menu-item-active': isActive(nav.path),
                      'menu-item-inactive': !isActive(nav.path),
                    }"
                    pTooltip="{{ isSidebarCollapsed() ? nav.name : '' }}"
                    tooltipPosition="right"
                  >
                    <span
                      class="menu-item-icon-size"
                      [ngClass]="{
                        'menu-item-icon-active': isActive(nav.path),
                        'menu-item-icon-inactive': !isActive(nav.path),
                      }"
                    >
                      <ng-container
                        *ngTemplateOutlet="
                          navIcon;
                          context: { $implicit: nav.icon }
                        "
                      ></ng-container>
                    </span>
                    @if ((isExpanded$ | async) || (isMobileOpen$ | async)) {
                      <span class="menu-item-text">{{ nav.name }}</span>
                    }
                  </a>
                }
              </li>
            }
          </ul>
        </div>
      </div>
    </nav>
  </div>

  <!-- COLLAPSED SIDEBAR POPUP -->
  @if (isSidebarCollapsed() && openSubmenu) {
    <div
      id="collapsed-submenu-popup"
      class="fixed z-[99999] min-w-[220px] rounded-xl bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-700 shadow-2xl p-2"
      (mouseleave)="hideCollapsedSubmenu()"
    >
      <!-- TOP ITEMS -->
      @for (nav of topLevelItems; track nav.name) {
        @if (openSubmenu === nav.name && nav.subItems) {
          <div class="flex flex-col gap-1">
            <div
              class="px-3 py-2 text-sm font-bold uppercase text-gray-900 dark:text-white"
            >
              {{ nav.name }}
            </div>
            @for (subItem of nav.subItems; track subItem.name) {
              <a
                [routerLink]="subItem.path"
                routerLinkActive="bg-gray-200 dark:bg-gray-800"
                class="px-3 py-2 rounded-lg text-sm text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800 hover:text-gray-900 dark:hover:text-white"
              >
                {{ subItem.name }}
              </a>
            }
          </div>
        }
      }

      <!-- MAP NAV -->
      @for (nav of mapItems; track nav.name) {
        @if (openSubmenu === nav.name && nav.subItems) {
          <div class="flex flex-col gap-1">
            <div
              class="px-3 py-2 text-sm font-semibold text-gray-500 dark:text-gray-400"
            >
              {{ nav.name }}
            </div>
            @for (subItem of nav.subItems; track subItem.name) {
              @if (hasNestedSubItems(subItem)) {
                <div
                  class="px-3 pt-2 text-xs font-bold uppercase text-gray-900 dark:text-white"
                >
                  {{ getSubItemName(subItem) }}
                </div>
                @for (
                  nestedItem of getNestedSubItems(subItem);
                  track nestedItem.name
                ) {
                  <a
                    [routerLink]="nestedItem.path"
                    class="ml-2 px-3 py-2 rounded-lg text-sm font-medium text-gray-500 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-800 hover:text-black dark:hover:text-white"
                  >
                    {{ nestedItem.name }}
                  </a>
                }
              } @else {
                <a
                  [routerLink]="getSubItemPath(subItem)"
                  class="px-3 py-2 rounded-lg text-sm font-medium text-gray-500 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-800 hover:text-black dark:hover:text-white"
                >
                  {{ getSubItemName(subItem) }}
                </a>
              }
            }
          </div>
        }
      }

      <!-- FILE NAV -->
      @for (nav of fileDefinitionItems; track nav.name) {
        @if (openSubmenu === nav.name && nav.subItems) {
          <div class="flex flex-col gap-1">
            <div
              class="px-3 py-2 text-sm font-semibold text-gray-500 dark:text-gray-400"
            >
              {{ nav.name }}
            </div>
            @for (subItem of nav.subItems; track subItem.name) {
              @if (hasNestedSubItems(subItem)) {
                <div
                  class="px-3 pt-2 text-xs font-bold uppercase text-gray-900 dark:text-white"
                >
                  {{ getSubItemName(subItem) }}
                </div>
                @for (
                  nestedItem of getNestedSubItems(subItem);
                  track nestedItem.name
                ) {
                  <a
                    [routerLink]="nestedItem.path"
                    class="ml-2 px-3 py-2 rounded-lg text-sm font-medium text-gray-500 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-800 hover:text-black dark:hover:text-white"
                  >
                    {{ nestedItem.name }}
                  </a>
                }
              } @else {
                <a
                  [routerLink]="getSubItemPath(subItem)"
                  class="px-3 py-2 rounded-lg text-sm font-medium text-gray-500 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-800 hover:text-black dark:hover:text-white"
                >
                  {{ getSubItemName(subItem) }}
                </a>
              }
            }
          </div>
        }
      }

      <!-- PARTNER NAV -->
      @for (nav of partnerManagementItems; track nav.name) {
        @if (openSubmenu === nav.name && nav.subItems) {
          <div class="flex flex-col gap-1">
            <div
              class="px-3 py-2 text-sm font-semibold text-gray-500 dark:text-gray-400"
            >
              {{ nav.name }}
            </div>
            @for (subItem of nav.subItems; track subItem.name) {
              @if (hasNestedSubItems(subItem)) {
                <div
                  class="px-3 pt-2 text-xs font-bold uppercase text-gray-900 dark:text-white"
                >
                  {{ getSubItemName(subItem) }}
                </div>
                @for (
                  nestedItem of getNestedSubItems(subItem);
                  track nestedItem.name
                ) {
                  <a
                    [routerLink]="nestedItem.path"
                    class="ml-2 px-3 py-2 rounded-lg text-sm font-medium text-gray-500 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-800 hover:text-black dark:hover:text-white"
                  >
                    {{ nestedItem.name }}
                  </a>
                }
              } @else {
                <a
                  [routerLink]="getSubItemPath(subItem)"
                  class="px-3 py-2 rounded-lg text-sm font-medium text-gray-500 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-800 hover:text-black dark:hover:text-white"
                >
                  {{ getSubItemName(subItem) }}
                </a>
              }
            }
          </div>
        }
      }

      <!-- DEVELOPER NAV -->
      @for (nav of developerItems; track nav.name) {
        @if (nav.path) {
          <a
            [routerLink]="nav.path"
            class="px-3 py-2 rounded-lg text-sm font-medium text-gray-500 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-800 hover:text-black dark:hover:text-white"
          >
            {{ nav.name }}
          </a>
        }
      }
    </div>
  }

  <!-- ICON TEMPLATE: renders an icon by key (no innerHTML, no sanitizer bypass) -->
  <ng-template #navIcon let-name>
    @switch (name) {
      @case ("dashboard") {
        <svg
          width="1em"
          height="1em"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M5.5 3.25C4.25736 3.25 3.25 4.25736 3.25 5.5V8.99998C3.25 10.2426 4.25736 11.25 5.5 11.25H9C10.2426 11.25 11.25 10.2426 11.25 8.99998V5.5C11.25 4.25736 10.2426 3.25 9 3.25H5.5ZM4.75 5.5C4.75 5.08579 5.08579 4.75 5.5 4.75H9C9.41421 4.75 9.75 5.08579 9.75 5.5V8.99998C9.75 9.41419 9.41421 9.74998 9 9.74998H5.5C5.08579 9.74998 4.75 9.41419 4.75 8.99998V5.5ZM5.5 12.75C4.25736 12.75 3.25 13.7574 3.25 15V18.5C3.25 19.7426 4.25736 20.75 5.5 20.75H9C10.2426 20.75 11.25 19.7427 11.25 18.5V15C11.25 13.7574 10.2426 12.75 9 12.75H5.5ZM4.75 15C4.75 14.5858 5.08579 14.25 5.5 14.25H9C9.41421 14.25 9.75 14.5858 9.75 15V18.5C9.75 18.9142 9.41421 19.25 9 19.25H5.5C5.08579 19.25 4.75 18.9142 4.75 18.5V15ZM12.75 5.5C12.75 4.25736 13.7574 3.25 15 3.25H18.5C19.7426 3.25 20.75 4.25736 20.75 5.5V8.99998C20.75 10.2426 19.7426 11.25 18.5 11.25H15C13.7574 11.25 12.75 10.2426 12.75 8.99998V5.5ZM15 4.75C14.5858 4.75 14.25 5.08579 14.25 5.5V8.99998C14.25 9.41419 14.5858 9.74998 15 9.74998H18.5C18.9142 9.74998 19.25 9.41419 19.25 8.99998V5.5C19.25 5.08579 18.9142 4.75 18.5 4.75H15ZM15 12.75C13.7574 12.75 12.75 13.7574 12.75 15V18.5C12.75 19.7426 13.7574 20.75 15 20.75H18.5C19.7426 20.75 20.75 19.7427 20.75 18.5V15C20.75 13.7574 19.7426 12.75 18.5 12.75H15ZM14.25 15C14.25 14.5858 14.5858 14.25 15 14.25H18.5C18.9142 14.25 19.25 14.5858 19.25 15V18.5C19.25 18.9142 18.9142 19.25 18.5 19.25H15C14.5858 19.25 14.25 18.9142 14.25 18.5V15Z"
            fill="currentColor"
          ></path>
        </svg>
      }
      @case ("document-tracker") {
        <svg
          aria-hidden="true"
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          fill="none"
          viewBox="0 0 24 24"
        >
          <path
            stroke="currentColor"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M10 3v4a1 1 0 0 1-1 1H5m4 10v-2m3 2v-6m3 6v-3m4-11v16a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V7.914a1 1 0 0 1 .293-.707l3.914-3.914A1 1 0 0 1 9.914 3H18a1 1 0 0 1 1 1Z"
          />
        </svg>
      }
      @case ("map-profile") {
        <svg
          width="1em"
          height="1em"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M3.25 5.5C3.25 4.25736 4.25736 3.25 5.5 3.25H18.5C19.7426 3.25 20.75 4.25736 20.75 5.5V18.5C20.75 19.7426 19.7426 20.75 18.5 20.75H5.5C4.25736 20.75 3.25 19.7426 3.25 18.5V5.5ZM5.5 4.75C5.08579 4.75 4.75 5.08579 4.75 5.5V8.58325L19.25 8.58325V5.5C19.25 5.08579 18.9142 4.75 18.5 4.75H5.5ZM19.25 10.0833H15.416V13.9165H19.25V10.0833ZM13.916 10.0833L10.083 10.0833V13.9165L13.916 13.9165V10.0833ZM8.58301 10.0833H4.75V13.9165H8.58301V10.0833ZM4.75 18.5V15.4165H8.58301V19.25H5.5C5.08579 19.25 4.75 18.9142 4.75 18.5ZM10.083 19.25V15.4165L13.916 15.4165V19.25H10.083ZM15.416 19.25V15.4165H19.25V18.5C19.25 18.9142 18.9142 19.25 18.5 19.25H15.416Z"
            fill="currentColor"
          ></path>
        </svg>
      }
      @case ("file-profile") {
        <svg
          width="1em"
          height="1em"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M8.50391 4.25C8.50391 3.83579 8.83969 3.5 9.25391 3.5H15.2777C15.4766 3.5 15.6674 3.57902 15.8081 3.71967L18.2807 6.19234C18.4214 6.333 18.5004 6.52376 18.5004 6.72268V16.75C18.5004 17.1642 18.1646 17.5 17.7504 17.5H16.248V17.4993H14.748V17.5H9.25391C8.83969 17.5 8.50391 17.1642 8.50391 16.75V4.25ZM14.748 19H9.25391C8.01126 19 7.00391 17.9926 7.00391 16.75V6.49854H6.24805C5.83383 6.49854 5.49805 6.83432 5.49805 7.24854V19.75C5.49805 20.1642 5.83383 20.5 6.24805 20.5H13.998C14.4123 20.5 14.748 20.1642 14.748 19.75L14.748 19ZM7.00391 4.99854V4.25C7.00391 3.00736 8.01127 2 9.25391 2H15.2777C15.8745 2 16.4468 2.23705 16.8687 2.659L19.3414 5.13168C19.7634 5.55364 20.0004 6.12594 20.0004 6.72268V16.75C20.0004 17.9926 18.9931 19 17.7504 19H16.248L16.248 19.75C16.248 20.9926 15.2407 22 13.998 22H6.24805C5.00541 22 3.99805 20.9926 3.99805 19.75V7.24854C3.99805 6.00589 5.00541 4.99854 6.24805 4.99854H7.00391Z"
            fill="currentColor"
          ></path>
        </svg>
      }
      @case ("business-process") {
        <svg
          class="w-6 h-6"
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          fill="none"
          viewBox="0 0 24 24"
        >
          <rect
            x="2"
            y="2"
            width="20"
            height="20"
            rx="4"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <line
            x1="12"
            y1="7"
            x2="12"
            y2="13"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
          />
          <circle cx="12" cy="17" r="1" fill="currentColor" />
        </svg>
      }
      @case ("status-management") {
        <svg
          class="w-6 h-6"
          aria-hidden="true"
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          fill="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            fill-rule="evenodd"
            d="M12 3a9 9 0 1 0 0 18h1a3 3 0 0 0 0-6h-1a1 1 0 1 1 0-2h1a5 5 0 0 1 0 10h-1A11 11 0 1 1 23 12a1 1 0 1 0-2 0 9 9 0 0 0-9-9Zm-4 9a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Zm2-4a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Zm6 4a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z"
            clip-rule="evenodd"
          />
        </svg>
      }
      @case ("payment-terms") {
        <i class="fa-solid fa-file-invoice-dollar text-lg"></i>
      }
      @case ("column-settings") {
        <svg
          class="w-6 h-6"
          aria-hidden="true"
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          fill="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            d="M10.83 5a3.001 3.001 0 0 0-5.66 0H4a1 1 0 1 0 0 2h1.17a3.001 3.001 0 0 0 5.66 0H20a1 1 0 1 0 0-2h-9.17ZM4 11h9.17a3.001 3.001 0 0 1 5.66 0H20a1 1 0 1 1 0 2h-1.17a3.001 3.001 0 0 1-5.66 0H4a1 1 0 1 1 0-2Zm1.17 6H4a1 1 0 1 0 0 2h1.17a3.001 3.001 0 0 0 5.66 0H20a1 1 0 1 0 0-2h-9.17a3.001 3.001 0 0 0-5.66 0Z"
          />
        </svg>
      }
      @case ("user-management") {
        <svg
          aria-hidden="true"
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          fill="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke="currentColor"
            stroke-linecap="round"
            stroke-width="2"
            d="M16 19h4a1 1 0 0 0 1-1v-1a3 3 0 0 0-3-3h-2m-2.236-4a3 3 0 1 0 0-4M3 18v-1a3 3 0 0 1 3-3h4a3 3 0 0 1 3 3v1a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1Zm8-10a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
          />
        </svg>
      }
      @case ("partners") {
        <i class="fa-regular fa-handshake fa-lg"></i>
      }
      @case ("regex") {
        <i class="fa-solid fa-code text-lg"></i>
      }
      @case ("announcement") {
        <i class="fa-solid fa-bullhorn text-lg"></i>
      }
      @case ("email-template") {
        <i class="fa-solid fa-envelope-circle-check fa-lg"></i>
      }
      @case ("role") {
        <i class="fa-solid fa-user-shield fa-lg"></i>
      }
      @case ("activity-log") {
        <i class="fa-solid fa-clock-rotate-left fa-lg"></i>
      }
      @case ("customer") {
        <i class="fa-solid fa-users-gear text-lg"></i>
      }
      @case ("api-clients") {
        <i class="fa-solid fa-key text-lg"></i>
      }
      @case ("documentation") {
        <i class="fa-solid fa-book-open text-lg"></i>
      }
      @case ("migration-new") {
        <i class="fa-solid fa-cloud-arrow-up text-lg"></i>
      }
      @case ("migration-requests") {
        <i class="fa-solid fa-list-check text-lg"></i>
      }
      @case ("migration-approvals") {
        <i class="fa-solid fa-user-check text-lg"></i>
      }
    }
  </ng-template>
</aside>
